import React from 'react';
import './Banner.scss';
import icon from '../../assets/banner/icons/Calling.webp';
import bannerImg from '../../assets/banner/1.webp';
import doctorImg from '../../assets/banner/doctor.webp';
import bannerPattern from '../../assets/banner/pattern_02.webp';
import shapeOne from '../../assets/banner/vector_01.webp';
import shapeTwo from '../../assets/banner/vector_02.webp';
import shapeThree from '../../assets/banner/vector_03.webp';
import shapeFour from '../../assets/banner/pattern.webp';
import { useBooking } from '../../components/BookingModal/BookingModal';

const Banner = () => {
    const { openBooking } = useBooking();

    return (
        <section className='section-bg section-common banner-section'>
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="banner-text" data-aos="fade-up" data-aos-duration="2000">
                                    <h1>Entrust your smile to professionals</h1>
                                    <p>Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.</p>

                                    <div className="banner-bottom">
                                        <div className="theme-btn">
                                            <button className="theme-btn-action" onClick={openBooking}>Book an appointment</button>
                                        </div>

                                        <div className="banner-call">
                                            <div className='icon'>
                                                <img src={icon} alt="icon" />
                                            </div>
                                            <div className='call-text'>
                                                <p>Dental 24H Emergency</p>
                                                <h6>03 482 394 123</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="banner-img-area" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                    <div className="banner-img">
                                        <img src={bannerImg} alt="banner model" />
                                    </div>
                                    <div className='info-box'>
                                        <div className="info-img">
                                            <img src={doctorImg} alt="doctor" />
                                        </div>
                                        <div className='info-text'>
                                            <p>Dr. Samantha Alice</p>
                                            <p><small>Consultant</small></p>
                                        </div>
                                    </div>  

                                    {/* Vector Shapes */}
                                    <div className="shapes">
                                        <img src={shapeOne} alt="shape" loading="lazy" />
                                        <img src={shapeTwo} alt="shape" loading="lazy" />
                                        <img src={shapeThree} alt="shape" loading="lazy" />
                                        <img src={shapeFour} alt="shape" loading="lazy" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Banner Pattern Vector*/}
            <img className='banner-pattern' src={bannerPattern} alt="banner pattern" loading="lazy" />
        </section>
    );
};

export default Banner;